/** Flagged areas sit under Zones: `/zones/flagged`, with the area being edited in a drawer at `/zones/flagged/new` or `/zones/flagged/:id`. */
export const FLAGGED_AREAS_PATH = '/zones/flagged';

export function flaggedAreaPath(id: string): string {
  return `${FLAGGED_AREAS_PATH}/${id}`;
}

export const NEW_FLAGGED_AREA_PATH = `${FLAGGED_AREAS_PATH}/new`;
